import * as React from "react";
const SvgDownArrow = (props) => /* @__PURE__ */ React.createElement("svg", { width: "18px", height: "9px", viewBox: "0 0 20 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 1.5L10 10.5L19 1.5", stroke: "#333333", strokeWidth: 2 }));
export default SvgDownArrow;
